import React from 'react';

export const ProfileCard = ({
  children,
  className = '',
  title,
  icon: IconComponent,
  color = 'bg-blue-100 dark:bg-blue-900/30',
  headerRight,
}) => (
  <div
    className={`bg-white dark:bg-[#1C1C1E] rounded-2xl md:rounded-[28px] p-3 md:p-6 shadow-sm border border-gray-100 dark:border-white/10 transition-all duration-300 ${className}`}
  >
    {(title || IconComponent || headerRight) && (
      <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
        {IconComponent && (
          <div
            className={`flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl ${color} text-blue-600 dark:text-blue-200 shrink-0`}
          >
            <IconComponent size={18} className="md:w-5 md:h-5" />
          </div>
        )}
        {title && <h3 className="text-sm md:text-lg font-semibold tracking-tight truncate text-gray-900 dark:text-white">{title}</h3>}
        {headerRight && <div className="ml-auto shrink-0">{headerRight}</div>}
      </div>
    )}
    {children}
  </div>
);

export const ProfileBadge = ({ children, type = 'neutral' }) => {
  const colors = {
    success: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300',
    warning: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
    neutral: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
    blue: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
    danger: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
  };
  return (
    <span className={`px-3 py-1 rounded-full text-xs font-semibold ${colors[type] || colors.neutral}`}>
      {children}
    </span>
  );
};

export const ProfileListItem = ({ label, value, subtext }) => (
  <div className="flex justify-between items-center py-3 border-b border-gray-100 dark:border-white/5 last:border-0 group">
    <div className="pr-4 min-w-0">
      <div className="text-sm font-medium text-gray-500 dark:text-gray-400 group-hover:text-gray-700 dark:group-hover:text-gray-200 transition-colors">
        {label}
      </div>
      {subtext && <div className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">{subtext}</div>}
    </div>
    <div className="text-right font-semibold text-sm md:text-base break-words max-w-[55%] text-gray-900 dark:text-white">
      {value || '—'}
    </div>
  </div>
);

export const profileInputBase =
  'w-full h-11 px-4 rounded-xl border text-sm transition-all outline-none bg-gray-50 dark:bg-white/5 text-gray-900 dark:text-white placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:ring-2 focus:ring-[#24299d]/20 focus:border-[#24299d] dark:focus:border-[#5a61e0] border-gray-200 dark:border-white/10';

export const profileInputDisabled =
  'w-full h-11 px-4 rounded-xl border text-sm bg-gray-100 dark:bg-white/[0.03] border-gray-200 dark:border-white/10 text-gray-500 dark:text-gray-500 cursor-not-allowed';

export const profileLabelClass = 'block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1.5';
